/**
 * @param field the field currently being examined
 * @param fields a string of the list of fields that have been evaluated in the rule
 * @param fieldName an array of strings used to hold a path of field names
 * @returns an updated version of fields.
 * 
 * can also recurse if a field has children
 */
function addFieldToList(field, fields, fieldName, crse) {
	// if the value is an array (the field has children)
	if (field.children) {
		// variable to hold current field name while being altered
		let currFieldName;

		// for each of the field's values (or children)
		for (let currField of field.children) {
			// reset the variable to be used for name altering
			currFieldName = '';
			// if the field has a keys array (is an object not an array) 
			// and has at least one key (this eliminates objects that don't have unique idenitifers) 
			if (field.keys && field.keys.length > 0) {
				// for every key
				for (let key of field.keys) {
					// add the key to the end of currFieldName
					currFieldName = currFieldName === '' ? currFieldName + key : currFieldName + ' ' + key;
				}
				// push the field with the keys added
				fieldName.push(currFieldName);
			}
			// call the function on the current child to dig further
			fields = addFieldToList(currField, fields, fieldName, crse);

			// find the index of the current field in fieldName
			const indexOfCurrentField = fieldName.findIndex(f => f === currFieldName || f === currField.name);
			// if the field is found in fieldName the remove it and all fields after it
			if (indexOfCurrentField !== -1) {
				fieldName.splice(indexOfCurrentField);
			}
		}

	// if the field itself is an array (this isn't being used right now but it might in the future so I'm leaving it for the time being)
	} else if (field.children) {
		for (let f of field) {
			fields = addFieldToList(f, fields, fieldName, crse);
		}

	// if the field is not an array and the field's does not have children then the field is a primitive type (string, date, or number)
	} else {
		// find the index of the current field in fieldName
		const indexOfCurrentField = fieldName.findIndex(f => f === field.name);
		// if the field is found in fieldName the remove it and all fields after it
		if (indexOfCurrentField !== -1) {
			fieldName.splice(indexOfCurrentField);
		}
		// push the field name to the path of field names
		fieldName.push(field.name);
		// if this is called while the crse object is being created include all field values
		if (crse) {
			fields.push({
				name: fieldName.join(' - '),
				value: field.value ?? 'NO VALUE',
				param: field.param,
				valid: field.valid
			});
		// if it is being called anywhere else include only the name and value
		} else {
			// join the field names in the path together ('Borrower Isaac Newton - Credit Score Reported')
			// and push the field into the rule's field list
			fields.push({
				name: fieldName.join(' - '),
				value: field.value ?? 'NO VALUE',
				valid: field.valid
			});
		}
	}
	// return the rule's list of fields
	return fields;
}

module.exports = {
	addFieldToList
}